import { useContext, useEffect, useMemo, useState } from 'react';
import ReactModal from 'react-modal';
import { toast } from 'react-toastify';
import { IoIosClose } from 'react-icons/io';

import Button from 'components/ui/button';
import { useModal } from 'context/ModalContext';
import Box from 'components/ui/box';
import { updateTask } from 'services/dashboard.service';
import { useAuth } from 'context/AuthContext';
import { actionLog } from 'services/actionlog.service';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  userToChange: string | undefined;
  data?: any;
}

export default function ModalTeamMemberExclude(props: Props) {
  ReactModal.setAppElement('#modal');

  const modalID = 'team-member-exclude';

  const { openModal, closeModal } = useModal();
  const { user } = useAuth();
  const { callback, status, id, userToChange, data } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [sending, setSending] = useState<boolean>(false);

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  const member = useMemo(() => {
    return data?.target?.find((x: { _id: string | undefined }) => x._id === userToChange);
  }, [data, userToChange]);

  const isGestor = useMemo(() => {
    return user?._id?.replace(/F(0+)?/gi, '') === member?.gestor;
  }, [user, member]);

  async function handleSubmit() {
    if (sending || !member) return false;

    setSending(true);

    try {
      const { action } = await actionLog('me', 'task_team_member_exclude', {
        taskId: data._id,
        player: userToChange,
      });

      const _success = action.attributes.status === 'OK';

      if (_success) {
        setSending(false);
        callback({ id: 'reload_task' });
        closeModal();

        toast.success(`Exclusão realizada com sucesso.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error(`Ocorreu um erro ao registrar sua ação. Por favor, tente novamente em alguns minutos.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        setSending(false);
      }
    } catch (error) {
      toast.error(`Ocorreu um erro ao registrar sua ação. Por favor, tente novamente em alguns minutos.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setSending(false);
    }
  }

  useEffect(() => {
    if (!!userToChange && data && typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal, data, userToChange]);

  if (!modalIsOpen || !member) return <></>;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Avaliação"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 bg-black bg-opacity-60 flex flex-col items-center w-screen h-screen p-6 pt-[10vh] overflow-y-auto"
        contentElement={() => (
          <Box className={`w-[90%] lg:w-auto lg:max-w-[600px]`}>
            <Button
              color="primary"
              className="absolute -right-5 -top-5 rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
              onClick={() => {
                if (!sending) closeModal();
              }}
              disabled={sending}
            >
              <IoIosClose color="white" size={40} />
            </Button>

            <>
              <div className="w-full lg:w-[536px] flex flex-col items-center justify-center space-y-8">
                <h4 className="block text-center text-yellow text-lg font-semibold leading-none">Excluir participação</h4>
                <p className="text-alice-blue text-base font-thin block">
                  Você está prestes a excluir {isGestor ? 'a' : 'sua'} participação desta Realização Destaque. Deseja confirmar
                  essa ação?
                </p>
                <button
                  className={`text-white bg-slate-blue text-sm inline-flex items-center justify-center font-semibold uppercase rounded py-3 px-4 leading-none`}
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={sending}
                >
                  CONFIRMAR
                </button>
              </div>
            </>
          </Box>
        )}
      />
    </>
  );
}
